export const QUESTION_TYPE_OPTIONS = [
  { value: 'select', label: 'Seleção' },
  { value: 'number', label: 'Nota (decimal)' },
  { value: 'integer', label: 'Nota (inteiro)' },
  { value: 'textarea', label: 'Texto Longo' },
  { value: 'text', label: 'Texto Curto' },
] as const;
